<div class="migo-dialog">
  <div class="migo-dialog__content" mat-dialog-content>
    <mg-icons class="mx-auto mb-5 h-12 w-12 block" name="timer"></mg-icons>
    <h6 class="title-6-bold mb-5 text-center font-outfit">
      {{ 'help.' + dialogType + '.title' | translate }}
    </h6>
    <div class="help-content" *ngIf="dialogType === 'cvv'">
      <p class="text-center font-outfit">
        {{ 'help.cvv.message' | translate }}
      </p>
      <div class="help-content__image">
        <img
          src="/assets/img/cvv_example.svg"
          alt="CVV Location on back of card example"
        />
      </div>
    </div>
    <div class="help-content" *ngIf="dialogType === 'date'">
      <p class="text-center font-outfit">
        {{ 'help.date.message' | translate }}
      </p>
      <div class="help-content__image">
        <img
          src="/assets/img/expiry_date_example.svg"
          alt="Expiry date location on card"
        />
      </div>
    </div>
    <div class="help-content" *ngIf="dialogType === 'info'">
      <p class="text-center font-outfit">
        {{ 'help.info.message' | translate }}
      </p>
    </div>
  </div>
  <div class="migo-dialog__actions w-full" mat-dialog-actions>
    <mg-button class="w-full" mat-dialog-close #ok>{{ 'common.buttons.accept' | translate }}</mg-button>
  </div>
</div>
